/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	// import { headerVisible } from "../include/module";
	(function () {
	
	  // ------------------------------------------------------------------------
	  // headerVisible
	  // -> SP ヘッダー出現
	  // ------------------------------------------------------------------------
	  // headerVisible();
	
	  // ------------------------------------------------------------------------
	  // headerToggle
	  // -> SP ヘッダー開閉
	  // ------------------------------------------------------------------------
	  (0, _module.headerToggle)();
	
	  // ------------------------------------------------------------------------
	  // newsTile
	  // -> NEWSタイトル 高さ調整
	  // ------------------------------------------------------------------------
	  (0, _module.newsTile)();
	
	  // ------------------------------------------------------------------------
	  // artistTile
	  // -> ARTIST名前 高さ調整
	  // ------------------------------------------------------------------------
	  (0, _module.artistTile)();
	
	  // ------------------------------------------------------------------------
	  // anchorLink
	  // -> リンク
	  // ------------------------------------------------------------------------
	  (0, _module.anchorLink)();
	
	  // ------------------------------------------------------------------------
	  // gc
	  // -> GoogleCalendar
	  // ------------------------------------------------------------------------
	  $('#js-Calendar').fullCalendar({
	    header: {
	      left: 'prev,next today',
	      center: 'title',
	      right: 'month,listYear'
	    },
	    displayEventTime: true,
	    googleCalendarApiKey: 'AIzaSyCqxPphPvXMaqVGcDvY91qBV0C-QGc9OgI',
	    events: 'straycatsrecords@gmail.com',
	    eventClick: function eventClick(event) {
	      // opens events in a popup window
	      window.open(event.url, 'gcalevent', 'width=700,height=600');
	      return false;
	    },
	    loading: function loading(bool) {
	      $('#loading').toggle(bool);
	    }
	  });
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var breakPoint = 750;
	
	var windowWidth = window.innerWidth;
	
	var headerBar = document.getElementById('js-Header--Bar');
	var headerMenu = document.getElementById('js-Header--Menu');
	var headerButtonOpen = document.getElementById('js-Header_Button_Open');
	var headerButtonClose = document.getElementById('js-Header_Button_Close');
	
	// ------------------------------------------------------------------------
	// headerVisible
	// -> SP ヘッダー出現
	// ------------------------------------------------------------------------
	// const headerVisible = () => {
	// if(windowWidth < breakPoint){
	//   window.addEventListener('scroll', () => {
	//     let scrollGoal   = windowWidth * 0.8;
	//     let scrollVolume = window.pageYOffset;
	//     if(scrollVolume > scrollGoal){
	//       headerBar.classList.remove('st-Header--Bar-Hidden');
	//     } else {
	//       headerBar.classList.add('st-Header--Bar-Hidden');
	//     }
	//   }, false);
	// }
	// }
	
	
	// ------------------------------------------------------------------------
	// headerToggle
	// -> SP ヘッダー開閉
	// ------------------------------------------------------------------------
	var headerToggle = function headerToggle() {
	  var headerStatus = false;
	  window.addEventListener('load', function () {
	    headerButtonOpen.addEventListener('click', function () {
	      if (!headerStatus) {
	        headerBar.classList.add('st-Header--Bar-Hidden');
	        headerMenu.classList.remove('st-Header--Menu-Hidden');
	        headerStatus = true;
	      }
	    }, false);
	    headerButtonClose.addEventListener('click', function () {
	      if (headerStatus) {
	        headerBar.classList.remove('st-Header--Bar-Hidden');
	        headerMenu.classList.add('st-Header--Menu-Hidden');
	        headerStatus = false;
	      }
	    }, false);
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// newsTile
	// -> NEWSタイトル 高さ調整
	// ------------------------------------------------------------------------
	var newsTile = function newsTile() {
	  window.addEventListener('load', function () {
	    if (windowWidth > breakPoint) {
	      $('.js-News_Title').tile(3);
	    } else {
	      $('.js-News_Title').tile();
	    }
	  }, false);
	  window.addEventListener('resize', function () {
	    var resizeWidth = window.innerWidth;
	    if (resizeWidth > breakPoint) {
	      $('.js-News_Title').tile(3);
	    } else {
	      $('.js-News_Title').tile();
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// artistTile
	// -> ARTIST名前 高さ調整
	// ------------------------------------------------------------------------
	var artistTile = function artistTile() {
	  window.addEventListener('load', function () {
	    $('.js-Artist').tile();
	    $('.js-Artist_Name').tile();
	  }, false);
	  window.addEventListener('resize', function () {
	    $('.js-Artist').tile();
	    $('.js-Artist_Name').tile();
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// discographyTile
	// -> DISCOGRAPHY CDタイトル 高さ調整
	// ------------------------------------------------------------------------
	var discographyTile = function discographyTile(targetClass) {
	  window.addEventListener('load', function () {
	    if (windowWidth > breakPoint) {
	      $(targetClass).tile(4);
	    } else {
	      $(targetClass).tile(2);
	    }
	  }, false);
	  window.addEventListener('resize', function () {
	    var resizeWidth = window.innerWidth;
	    if (resizeWidth > breakPoint) {
	      $(targetClass).tile(4);
	    } else {
	      $(targetClass).tile(2);
	    }
	  }, false);
	};
	
	// ------------------------------------------------------------------------
	// anchorLink
	// -> リンク
	// ------------------------------------------------------------------------
	var anchorLink = function anchorLink() {
	  $("a[href^='#']").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkHeight = 0;
	    if (windowWidth < breakPoint) {
	      linkHeight = windowWidth * 0.21;
	    }
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkPosition = linkTarget.offset().top - linkHeight;
	    $("html, body").animate({ scrollTop: linkPosition }, linkSpeed, "swing");
	    return false;
	  });
	};
	
	// ------------------------------------------------------------------------
	// export
	// ------------------------------------------------------------------------
	exports.headerToggle = headerToggle;
	exports.newsTile = newsTile;
	exports.artistTile = artistTile;
	exports.discographyTile = discographyTile;
	exports.anchorLink = anchorLink;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// event_live/app.bundle.js